import { useEffect, useState } from 'react'
import styled from 'styled-components'

type PriceInputProps = {
  onValueChange: (value: number) => void
  focus: boolean
}

// ========================= React Component ===================================

const PriceInput = ({ onValueChange, focus }: PriceInputProps): JSX.Element => {
  const [digits, setDigits] = useState(1)

  useEffect(() => {
    if (focus) {
      const element = document.getElementById('price-input')
      element?.focus()
    } else {
      const element = document.getElementById('price-input')
      element?.blur()
    }
  }, [focus])

  return (
    <Row>
      <TextField
        id="price-input"
        inputMode="decimal"
        onInput={(e) => {
          e.currentTarget.value = e.currentTarget.value
            .replace(/[^0-9.]/g, '')
            .replace(/(\..*)\./g, '$1')
        }}
        size={digits}
        placeholder="0"
        onChange={(change) => {
          const length = change.target.value.length
          setDigits(length > 0 ? change.target.value.length : 1)

          const number = Number(change.target.value)
          onValueChange(number)
        }}
      />
      <SOLLabel>SOL</SOLLabel>
    </Row>
  )
}

export default PriceInput

// ========================= Styled Components =================================

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

const TextField = styled.input`
  border-style: none;
  border-color: none;
  background-color: none;
  background: none;
  color: white;
  font-size: 60px;
  font-weight: 500;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: -10px;

  color: #e0e0e0;

  -moz-appearance: textfield;

  ::placeholder {
    color: #7d7d7d;
  }

  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus {
    outline: none;
  }

  @media (min-width: 43em) {
    margin-right: -5px;
  }
`

const SOLLabel = styled.div`
  font-size: 60px;
  font-weight: 500;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;

  @media (max-width: 43em) {
    margin-bottom: 5px;
  }
`
